export function pushRawGTMEvent(eventObject: Record<string, unknown>): void {
  // syntax `'dataLayer' in window doesn't work in 2.4.2
  if (window.dataLayer) {
    window.dataLayer.push(eventObject);
  }
}

export const pushGTMEvent = <T extends GA4Event>(event: T, params: GA4EventParams[T]) => {
  pushRawGTMEvent({
    event,
    ...params,
  });
};

export enum GAProductListItemId {
  Selection = 'selection',
  Lookbook = 'lookbook',
}

export enum GAProductListItemName {
  Selection = 'Selection products',
  Lookbook = 'Lookbook products',
}

export type GA4Event =
  | 'client_page_view'
  | 'view_item'
  | 'view_item_list'
  | 'select_item'
  | 'add_to_wishlist'
  | 'add_to_cart'
  | 'remove_from_cart'
  | 'view_cart'
  | 'begin_checkout'
  | 'add_payment_info'
  | 'purchase'
  | 'refund'
  | 'search'
  | 'login'
  | 'sign_up'
  | 'view_promotion'
  | 'select_promotion';

export interface GA4EventParams {
  client_page_view: object;
  view_item: {
    ecommerce: {
      currency?: string;
      value?: number;
      items: GAItem[];
    };
  };
  view_item_list: {
    ecommerce: {
      currency?: string;
      item_list_id?: string;
      item_list_name?: string;
      items: GAItem[];
    };
  };
  select_item: {
    ecommerce: {
      items: GAItem[];
    };
  };
  add_to_cart: {
    ecommerce: {
      currency?: string;
      value?: number;
      items: GAItem[];
    };
  };
  remove_from_cart: {
    ecommerce: {
      currency?: string;
      value?: number;
      items: GAItem[];
    };
  };
  view_cart: {
    ecommerce: {
      currency: string;
      value: number;
      items: GAItem[];
    };
  };
  begin_checkout: {
    ecommerce: {
      currency: string;
      value: number;
      items: GAItem[];
    };
  };
  add_payment_info: {
    ecommerce: {
      currency: string;
      value: number;
      payment_type: string;
      items: GAItem[];
    };
  };
  purchase: {
    ecommerce: {
      transaction_id: string;
      currency: string;
      value: number;
      tax?: number;
      shipping?: number;
      coupon?: string;
      items: GAItem[];
    };
  };
  refund: {
    ecommerce: {
      transaction_id: string;
      currency: string;
      value: number;
    };
  };
  search: {
    search_term: string;
  };
  login: {
    ecommerce: {
      method: string;
    };
  };
  sign_up: {
    ecommerce: {
      method: string;
    };
  };
  view_promotion: {
    ecommerce: {
      items: Promotion[];
    };
  };
  select_promotion: {
    ecommerce: {
      items: Promotion[];
    };
  };
  add_to_wishlist: {
    ecommerce: {
      currency?: string;
      value?: number;
      items: GAItem[];
    };
  };
  share: {
    ecommerce: {
      method: string;
      content_type?: string;
      item_id?: string;
    };
  };
}

export interface GAItem {
  item_id: string;
  item_name: string;
  quantity?: number;
  price?: number;
  affiliation?: string;
  coupon?: string;
  discount?: number;
  index?: number;
  item_brand?: string;
  item_category?: string;
  item_category2?: string;
  item_category3?: string;
  item_category4?: string;
  item_category5?: string;
  item_list_id?: string;
  item_list_name?: string;
  item_variant?: string;
  location_id?: string;

  [key: string]: any;
}

export interface Promotion {
  promotion_id: string;
  promotion_name: string;
  [key: string]: any;
}
